import WTooltip from './tooltip.vue';
import WPreview from './preview-value.vue';
import WInput from './input.vue';
import WTextarea from './textarea.vue';
import WCheckbox from './checkbox.vue';
import WRadio from './radio';
import WError from './error.vue';
import WButton from './button.vue';
import WPagination from './pagination.vue';
import WSelect from './select.vue';
import WDatepicker from './datepicker.vue';
import WModal from './modal.vue';
import WSection from './section.vue';
import WCrossedOut from './crossed-out.vue';
import WAutoText from './auto-text.vue';
import WAlert from './alert.vue';
import WAddRow from './add-row.vue';
import WRowButtons from './row-buttons.vue';
import WTableCell from './table-cell.vue';
import WLpCell from './lp-cell.vue';
import WFormTable from './form-table.vue';
import WSpoiler from './spoiler.vue';
import WRadioList from './radio-list.vue';
import WMonaco from './monaco.vue';
import WTercPicker from './tercPicker.vue';
import WSimcPicker from './simcPicker.vue';
import WUlicPicker from './ulicPicker.vue';
import WTerytPicker from './terytPicker.vue';

//shared components
import WAddress from './shared/Address.vue';
import WLegalForm from './shared/LegalForm.vue';
import WSphere from './shared/Sphere.vue';
import WFormDevTools from './shared/FormDevTools.vue';

export const components = {
  WInput,
  WPreview,
  WTextarea,
  WPagination,
  WSelect,
  WDatepicker,
  WModal,
  WRadio,
  WTooltip,
  WError,
  WAddRow,
  WRowButtons,
  WButton,
  WCheckbox,
  WSection,
  WTableCell,
  WCrossedOut,
  WAutoText,
  WAlert,
  WLpCell,
  WFormTable,
  WSpoiler,
  WRadioList,
  WMonaco,
  WTercPicker,
  WSimcPicker,
  WUlicPicker,
  WTerytPicker,

  WAddress,
  WLegalForm,
  WSphere,
  WFormDevTools
};

export function registerComponents(Vue, registerLog) {
  for (var name in components) {
    if (registerLog) {
      console.time('register ' + name);
      Vue.component(name, components[name]);
      console.timeEnd('register ' + name);
    } else {
      Vue.component(name, components[name]);
    }
  }
}

export default components;
